import { HitInlineLoader } from "./HitInlineLoader";
import { HitSkeletonGrid } from "./HitSkeletonCard";
import { useFullLoader } from "./store";

// Pinta el nivel que devuelve useLoadingLevel: inline = tarjeta (+ grilla), full = pantalla completa.
export function HitSectionLoading({ level, loading, section, grid = false, gridClassName, desktopCols, onRetry, steps = "page", className = "" }) {
  useFullLoader(level === "full", { step: loading ? 0 : 3, steps, onRetry });
  if (level === "none") return null;
  return (
    <div className={`hl-section ${className}`} data-testid={`hit-section-loading-${section}`}>
      <HitInlineLoader section={section} onRetry={onRetry} />
      {grid && <HitSkeletonGrid className={gridClassName} desktopCols={desktopCols} />}
    </div>
  );
}
